import { Component, inject } from '@angular/core';
import { FgbModalService } from 'src/app/shared/components/modals/fgb-modal.service';

@Component({
  selector: 'fgb-quiz-how-it-works-modal',
  templateUrl: './quiz-how-it-works-modal.component.html',
  styleUrl: './quiz-how-it-works-modal.component.scss',
})
export class QuizHowItWorksModalComponent {
  private modalService = inject(FgbModalService);

  close(): void {
    this.modalService.close();
  }
}
